import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=1a6ccfa7&scoped=true"
import script from "./SignUpForm.vue?vue&type=script&lang=js"
export * from "./SignUpForm.vue?vue&type=script&lang=js"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=1a6ccfa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6ccfa7",
  null
  
)

export default component.exports